import React from 'react';
import { Link } from 'react-router-dom';
import { LuArrowLeft, LuSun, LuMoon, LuMonitor } from 'react-icons/lu';
import Page from '../../components/ui/Page/Page';
import PageHeader from '../../components/ui/PageHeader/PageHeader';
import Card from '../../components/ui/Card/Card';
import Button from '../../components/ui/Button/Button';
import { useTheme } from '../../theme/theme';
import './AppearanceSettingsPage.less';

const OPTIONS = [
  { value: 'light',  label: 'Light',  desc: 'Bright, high contrast.',    icon: LuSun },
  { value: 'dark',   label: 'Dark',   desc: 'Easier on the eyes at night.', icon: LuMoon },
  { value: 'system', label: 'System', desc: 'Match your device.',           icon: LuMonitor },
];

function AppearanceSettingsPage() {
  const { preference, setPreference } = useTheme();

  return (
    <Page>
      <PageHeader
        title="Appearance"
        subtitle="Choose how GreenCharge looks on this device."
        action={
          <Button as={Link} to="/settings" variant="ghost" leadingIcon={<LuArrowLeft />}>
            Back
          </Button>
        }
      />

      <Card>
        <div className="gc-appearance-list" role="radiogroup" aria-label="Theme">
          {OPTIONS.map(({ value, label, desc, icon: Icon }) => {
            const selected = preference === value;
            return (
              <button
                type="button"
                key={value}
                role="radio"
                aria-checked={selected}
                className={`gc-appearance-option${selected ? ' is-selected' : ''}`}
                onClick={() => setPreference(value)}
              >
                <span className="gc-appearance-icon" aria-hidden="true"><Icon /></span>
                <span className="gc-appearance-body">
                  <span className="gc-appearance-title">{label}</span>
                  <span className="gc-appearance-desc">{desc}</span>
                </span>
                <span className="gc-appearance-dot" aria-hidden="true" />
              </button>
            );
          })}
        </div>
      </Card>
    </Page>
  );
}

export default AppearanceSettingsPage;
